import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function CameraIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.66797 6.5C1.66797 5.09987 1.66797 4.3998 1.94045 3.86502C2.18014 3.39462 2.56259 3.01217 3.03299 2.77248C3.56777 2.5 4.26784 2.5 5.66797 2.5H14.3346C15.7348 2.5 16.4348 2.5 16.9696 2.77248C17.44 3.01217 17.8225 3.39462 18.0622 3.86502C18.3346 4.3998 18.3346 5.09987 18.3346 6.5V13.5C18.3346 14.9001 18.3346 15.6002 18.0622 16.135C17.8225 16.6054 17.44 16.9878 16.9696 17.2275C16.4348 17.5 15.7348 17.5 14.3346 17.5H5.66797C4.26784 17.5 3.56777 17.5 3.03299 17.2275C2.56259 16.9878 2.18014 16.6054 1.94045 16.135C1.66797 15.6002 1.66797 14.9001 1.66797 13.5V6.5Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0013 13.3333C11.8423 13.3333 13.3346 11.8409 13.3346 10C13.3346 8.15905 11.8423 6.66667 10.0013 6.66667C8.16035 6.66667 6.66797 8.15905 6.66797 10C6.66797 11.8409 8.16035 13.3333 10.0013 13.3333Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  )
}
